// extracted by mini-css-extract-plugin
module.exports = {"gdpr":"Gdpr-module--gdpr--3Q7MM"};